import React from 'react';
import { Star, Shield } from 'lucide-react';

/**
 * TrustpilotWidget
 * Reserviert den Platz für ein echtes Trustpilot-Widget.
 * Setze die folgenden Werte, sobald der Trustpilot-Business-Account verifiziert ist:
 *   - BUSINESS_UNIT_ID:  Deine eindeutige Trustpilot-Business-ID
 *   - LOCALE / THEME:    Optional anpassbar
 *
 * Bis dahin zeigen wir einen sauberen "Coming Soon"-Placeholder mit Trust-Style.
 * Wenn BUSINESS_UNIT_ID gesetzt ist, wird das offizielle Trustpilot-Script geladen.
 */
const BUSINESS_UNIT_ID = process.env.REACT_APP_TRUSTPILOT_BUSINESS_ID || '';
const TEMPLATE_ID = '53aa8807dec7e10d38f59f32'; // Mini Trust-Widget

const TrustpilotWidget = ({ compact = false }) => {
  React.useEffect(() => {
    if (!BUSINESS_UNIT_ID) return;
    // Lazy-load Trustpilot bootstrap script
    if (document.getElementById('trustpilot-bootstrap')) return;
    const script = document.createElement('script');
    script.id = 'trustpilot-bootstrap';
    script.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    script.async = true;
    document.head.appendChild(script);
  }, []);

  // If real Trustpilot is configured → render official widget
  if (BUSINESS_UNIT_ID) {
    return (
      <div
        className="trustpilot-widget"
        data-locale="de-DE"
        data-template-id={TEMPLATE_ID}
        data-businessunit-id={BUSINESS_UNIT_ID}
        data-style-height={compact ? '24px' : '150px'}
        data-style-width="100%"
        data-theme="light"
        data-testid="trustpilot-widget"
      >
        <a
          href={`https://de.trustpilot.com/review/medicalpi.de`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Trustpilot-Bewertungen
        </a>
      </div>
    );
  }

  // Placeholder until Trustpilot account is verified
  return (
    <div
      className={`inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 text-white/80 border border-white/15 ${compact ? 'text-sm' : ''}`}
      data-testid="trustpilot-placeholder"
      aria-label="Trustpilot Bewertungen – bald verfügbar"
      title="Trustpilot Bewertungen werden bald verfügbar sein"
    >
      <Star className="w-4 h-4 fill-amber-400 text-amber-400" />
      <span className="font-semibold">Bewertungen demnächst</span>
      <Shield className="w-4 h-4 text-emerald-400" />
    </div>
  );
};

export default TrustpilotWidget;
